import Link from "next/link";
import MwContactUs, { type ContactUsProductVariant } from "./contact-us";
import type { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import "./styles/_agent-installation.module.scss";

type AgentDeployItem = {
    title: string;
    link: string;
    icon: ReactNode;
};


const MwAgents = ({
    agentDeploy,
    title,
    description,
    contactUsVariant,
    nameClass,
}: {
    agentDeploy: AgentDeployItem[];
    title?: ReactNode;
    contactUsVariant?: ContactUsProductVariant;
    description?: string;
    nameClass?: string;
}) => {
    const { t } = useTranslation("common");

    return <>
        <section className={`agent-installation ${nameClass ? nameClass : ""}`}>
            <div className={'container'}>
                <div className="header-flex">
                    <div className="left-block">
                        <div className={'section-tag'}>{t('home.readyToStart.agentIntegration.tag')}</div>
                        {title}
                    </div>
                    <div className="right-block">
                        <p>{description ?? "Achieve complete infrastructure visibility in minutes with effortless, single-script deployment, giving your team confidence in quick setup and encouraging adoption."}</p>
                    </div>
                </div>

                <div className={"d-flex"}>
                    {
                        agentDeploy.map((agent, index) => {
                            return <div className={"agent-item"} key={index}>
                                {agent.icon}
                                <h4>{agent.title}</h4>
                                <Link href={agent.link} target={"_blank"}><p className={"read-more"}>{t('home.readyToStart.agentIntegration.viewDocs')}</p></Link>
                            </div>
                        })
                    }
                </div>
                <MwContactUs variant={contactUsVariant} />
            </div>
        </section>
    </>
}
export default MwAgents